<template>
    <SOSlotModal
        modal-title="Detail Promo"
        :modal-id="id"
        :no-padding="true"
        @close="close()"
    >
        <template v-slot:modal-body>
            <div class="p-4">
                <p class="f-bold">{{ mcoinEstimation.ActiveCoupon.kode }}</p>
                <p class="m-d-0">
                    Diskon {{ mcoinEstimation.ActiveCoupon.diskon }}% Menjalankan Jadwal Otomatis
                    Berlaku {{ $moment(mcoinEstimation.ActiveCoupon.expired).format("DD MMM YYYY") }}
                    Sisa Pengunaan {{ mcoinEstimation.ActiveCoupon.quotaRemaining }} X 
                </p>
            </div>
        </template>
    </SOSlotModal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../../store/state";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
    name: "DetailPromoModal",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            id: "DetailPromoModal",
        }
    },
    mounted() {
        this.getCoinEstimation();
    },
    computed: {
        ...mapGetters(moduleName, {
            mcoinEstimation: "mcoinEstimation",
        }),
    },
    methods: {
        ...mapActions({
            getCoinEstimation: `${moduleName}/getCoinEstimation`,
        }),
        open() {
            $("#" + this.id).modal("show");
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
    },
}
</script>